import React from "react";
import { EnvelopeSimple, CheckCircle, Calendar, FileText } from "@phosphor-icons/react";

const steps = [
  {
    icon: EnvelopeSimple, num: "01", title: "Azonnali visszaigazolás",
    desc: "Amint elküldi az ajánlatkérést, e-mailt kap: rögzítettük az igényét, és pontosan mit várhat a következő órákban.",
  },
  {
    icon: FileText, num: "02", title: "Személyre szabott ajánlat",
    desc: "24 munkaórán belül e-mailben megkapja a tételes, fix árú ajánlatot PDF-ben. Átbeszéljük telefonon is.",
  },
  {
    icon: Calendar, num: "03", title: "Ütemezés és helyszín",
    desc: "Egyeztetünk egy helyszínfelmérési időpontot. Ha minden rendben, fix dátum kerül a szerződésbe.",
  },
  {
    icon: CheckCircle, num: "04", title: "Emlékeztetők, haladás",
    desc: "Minden mérföldkőnél e-mailt küldünk: gyártás indult, szállítás napja, csapat érkezik. Nulla bizonytalanság.",
  },
];

export default function EmailAutomation() {
  return (
    <section id="email-automation" data-testid="email-automation-section" className="py-20 md:py-32 bg-[#FFFFFF] border-y border-[#E4E4E7]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="max-w-3xl mb-12 md:mb-16">
          <span className="badge-chip" style={{ background: "#0F0F0F", color: "#FFFFFF" }}>
            Automatizált ügyintézés
          </span>
          <h2 className="font-display font-black text-4xl md:text-5xl lg:text-6xl tracking-tight mt-4 leading-[0.95]">
            Nincs találgatás.<br/>Minden lépésről szólunk.
          </h2>
          <p className="text-[#525252] mt-4 text-base md:text-lg">
            Az ajánlatkéréstől a kulcsátadásig — e-mailben tájékoztatjuk minden fontos lépésről. Tudni fogja, hol tart a projektje, ki jön legközelebb, mit kell előkészíteni.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#E4E4E7] border border-[#E4E4E7]">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <div key={i} data-testid={`email-step-${i}`} className="bg-white p-6 md:p-8 relative group hover:bg-[#F5F5F5] transition-colors">
                <div className="text-6xl font-display font-black text-[#F5F5F5] absolute top-4 right-4 leading-none select-none">
                  {s.num}
                </div>
                <div className="relative">
                  <div className="w-12 h-12 bg-[#0F0F0F] flex items-center justify-center rounded-sm mb-4">
                    <Icon size={22} weight="duotone" className="text-[#FFFFFF]" />
                  </div>
                  <h3 className="font-display font-bold text-xl tracking-tight mb-2">{s.title}</h3>
                  <p className="text-[#525252] text-sm leading-relaxed">{s.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
